import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faUser,
  faList,
  faKey,
  faHouseUser,
  faCog,
  faRupeeSign,
  faAtom,
  faCopyright,
  faFileContract,
  faChartLine,
  faFileAlt,
  faShieldAlt,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../SideMenu.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import { getUserType } from "../utils/index";

var revenueReportText = "Revenue Report";
if(getUserType() == "Occupier") {
  revenueReportText = "Expense Report";
}

class ReportsSideMenu extends React.Component {
  state = {
    openMenu: [""],
    activeKey: "1-1",
  };
  constructor(props) {
    super(props);
  }
  render() {
    let url = this.props.match;
    console.log(this.props.location.pathname);
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys, event) => {
            console.log(openKeys[openKeys.length - 1]);
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
        >
          <Sidenav.Body>
            <Nav>
              <Dropdown
                eventKey="1"
                title="INVOICING"
                // icon={<FontAwesomeIcon icon={faTable} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/generate`}
                  onSelect={() => {
                    this.state.activeKey = "1-2";
                  }}
                  eventKey="1-2"
                >
                  GENERATE INVOICES
                </Dropdown.Item>

                {/* <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/approve`}
                  onSelect={() => {
                    this.state.activeKey = "1-3";
                  }}
                  eventKey="1-3"
                >
                  APPROVE INVOICES
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/apply`}
                  onSelect={() => {
                    this.state.activeKey = "1-3";
                  }}
                  eventKey="1-3"
                >
                  APPLY INVOICES
                </Dropdown.Item> */}
              </Dropdown>

              <Dropdown
                eventKey="2"
                title="DEBIT-CREDIT NOTES"
                // icon={<FontAwesomeIcon icon={faChartLine} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/debit`}
                  onSelect={() => {
                    this.state.activeKey = "2-1";
                  }}
                  eventKey="2-1"
                >
                  DEBIT NOTES
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/credit`}
                  onSelect={() => {
                    this.state.activeKey = "2-2";
                  }}
                  eventKey="2-2"
                >
                  CREDIT NOTES
                </Dropdown.Item>


              </Dropdown>

              <Dropdown
                eventKey="3"
                componentClass={Link}
                to={`${url.path}/lease-documentation`}
                //onClick={alert(1)}
                title="PRINT & SEND INVOICES"
                // icon={<FontAwesomeIcon icon={faRupeeSign} />}
              >
                <Dropdown.Item
                  onSelect={() => {
                    this.state.activeKey = "3-1";
                  }}
                  onClick={() => {
                    this.state.activeKey = "3";
                    this.props.history.push({
                      pathname: `${url.path}/print`,
                    });
                  }}
                  eventKey="3-1"
                >
                  PRINT & SEND INVOICES
                </Dropdown.Item>
                
              </Dropdown>

              <Dropdown
                eventKey="7"
                title="RECEIPTS"
                // icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "4";
                  // this.props.history.push({
                  //   pathname: `${url.path}/lease-security-deposit`,
                  // });
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/general`}
                  onSelect={() => {
                    this.state.activeKey = "4-1";
                  }}
                  eventKey="4-1"
                > 
                  GENERAL RECEIPTS
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/deposit`}
                  onSelect={() => {
                    this.state.activeKey = "4-2";
                  }}
                  eventKey="4-2"
                >
                  DEPOSIT RECEIPTS
                </Dropdown.Item>

              </Dropdown>

              <Dropdown
                eventKey="8"
                title="LEDGERS"
                // icon={<FontAwesomeIcon icon={faShieldAlt} />}
                onClick={() => {
                  this.state.activeKey = "5";
                  // this.props.history.push({
                  //   pathname: `${url.path}/lease-security-deposit`,
                  // });
                }}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/ledger-general`}
                  onSelect={() => {
                    this.state.activeKey = "5-1";
                  }}
                  eventKey="5-1"
                >
                  GENERAL LEDGERS
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/ledger-deposit`}
                  onSelect={() => {
                    this.state.activeKey = "5-2";
                  }}
                  eventKey="5-2"
                >
                  DEPOSIT LEDGERS
                </Dropdown.Item>

              </Dropdown>



            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(ReportsSideMenu);
